// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"416":"3f1ef2ba","538":"0d3fe210","545":"363a01e3","566":"fc8c8a2a","676":"17f0152c","826":"360cc31d"}[chunkId] + ".chunk.js";
};